import { render } from "./compatible-part-panel.vue?vue&type=template&id=88151970"
import script from "./compatible-part-panel.vue?vue&type=script&lang=js"
export * from "./compatible-part-panel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jamesc\\source\\repos\\ul-web-plugins\\src\\UL.VueCadPlugin.Client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__